import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { GLASS_EMAIL } from './ThemeToggle';

/** Gate global del tema Glass (beta): vive en App para cubrir TODOS los roles
    (admin, profesor, alumno). A Carlos se le enciende UNA sola vez (su elección
    posterior persiste); a cualquier otra cuenta que traiga 'glass' en
    localStorage se le normaliza a oscuro. No pinta nada. */
export default function GlassGate() {
  const { user } = useAuth();
  const { theme, setTheme } = useTheme();
  useEffect(() => {
    if (!user) return;
    const isGlassTester = user.email === GLASS_EMAIL;
    if (theme === 'glass' && !isGlassTester) { setTheme('dark'); return; }
    if (isGlassTester && !localStorage.getItem('lm-glass-intro')) {
      localStorage.setItem('lm-glass-intro', '1');
      setTheme('glass');
    }
  }, [user, theme, setTheme]);
  return null;
}
